import {PURGE} from 'redux-persist';
import {actions as A} from '../constants/actions';


const defaultState = {
  user: null,
  userTypeID: null,
  userId: null,
  firmLogo: null,
  allowInspectionsShare: false,
  adminPermissionsLevel: null,
  firmInspectionsAccess: false,
  loading: false,
  error: false,
  errorMessage: null
};

export const userReducer = (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.SET_USER:
      const {user} = payload;
      return {...state, user};

    case A.SET_USER_ID:
      const {userId} = payload;
      return {...state, userId};

    case A.SET_USER_TYPE_ID:
      const {userTypeID} = payload;
      return {...state, userTypeID};

    case A.SET_FIRM_LOGO:
      const {firmLogo} = payload;
      return {...state, firmLogo};

    case A.SET_ALLOW_SHARE:
      const {allowInspectionsShare} = payload;
      return {...state, allowInspectionsShare};

    case A.SET_ADMIN_PERMISSIONS_LEVEL:
      const {adminPermissionsLevel} = payload;
      return {...state, adminPermissionsLevel};

    case A.SET_FIRM_INSPECTIONS_ACCESS:
      const {firmInspectionsAccess} = payload;
      return {...state, firmInspectionsAccess};

    case A.SET_USER_PROPS:
      return {...state, ...payload};

    case A.LOGOUT:
    case PURGE:
      return defaultState;

    default:
      return state;
  }
};

